<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.07 90.07">
  <path class="cls-4" d="m45.87,66.12s-.06,0-.08,0c-.27-.05-.45-.3-.41-.57l3.13-18.62s0-.03-.07-.06c-.07-.03-.11.01-.12.03l-2.51,2.67c-.2.22-.48.34-.78.35-.29,0-.58-.11-.79-.31l-2.65-2.59s-.06-.05-.12-.02c-.07.03-.06.09-.06.11l2.92,18.46c.04.27-.14.52-.41.57-.27.04-.52-.14-.57-.41l-2.92-18.49c-.05-.5.2-.92.62-1.12.42-.2.91-.12,1.24.21l2.65,2.59s.06.03.08.03c.02,0,.05,0,.08-.03l2.51-2.67c.32-.34.81-.44,1.24-.26.43.19.69.61.66,1.08l-3.14,18.67c-.04.24-.25.41-.49.41Z"/>
  <path class="cls-1" d="m51.22,79.24h-12.37c-.64,0-1.16-.52-1.16-1.16s.52-1.16,1.16-1.16h12.37c.64,0,1.16.52,1.16,1.16s-.52,1.16-1.16,1.16Z"/>
  <path class="cls-1" d="m53.32,75.27h-16.57c-.64,0-1.16-.52-1.16-1.16s.52-1.16,1.16-1.16h16.57c.64,0,1.16.52,1.16,1.16s-.52,1.16-1.16,1.16Z"/>
  <path class="cls-1" d="m53.32,71.3h-16.57c-.64,0-1.16-.52-1.16-1.16s.52-1.16,1.16-1.16h16.57c.64,0,1.16.52,1.16,1.16s-.52,1.16-1.16,1.16Z"/>
  <path class="cls-2" d="m44.98,25.42v3.3c3.85,0,8.74,1.72,10.91,6.54.54,1.2.81,2.41.84,3.71.07,3.38-1.54,6.88-3.24,10.59-.33.71-.65,1.41-.96,2.12-1.44,3.24-2.28,5.83-2.75,8.4-.15.84-.21,1.65-.26,2.36-.03.46-.08,1.1-.16,1.49-.07,0-.16.01-.26.01h-.08s-6.53.06-6.53.06h-.12c-.91,0-1.32-.1-1.47-.15-.11-.24-.27-.86-.42-2.37-.35-3.47-1.24-7.02-2.64-10.58-.55-1.39-1.19-2.73-1.81-4.03-1.92-4.01-3.57-7.47-2.13-11.16,2.01-5.16,7.04-7,11.09-7v-3.3m0,0c-5.9,0-11.8,3.04-14.16,9.1-2.52,6.48,1.7,11.91,3.95,17.6,1.23,3.11,2.09,6.37,2.43,9.7.38,3.77.98,5.49,5.18,5.49.05,0,.1,0,.15,0,2.2-.02,4.4-.04,6.61-.06,4.27-.04,3.34-3.5,3.9-6.58.48-2.66,1.43-5.19,2.52-7.65,2.02-4.56,4.59-9.24,4.49-14.11-.03-1.64-.37-3.31-1.13-5-2.55-5.67-8.24-8.49-13.92-8.49h0Z"/>
  <g>
    <path class="cls-3" d="m45.04,19.37c-.73,0-1.32-.59-1.32-1.32v-5.9c0-.73.59-1.32,1.32-1.32s1.32.59,1.32,1.32v5.9c0,.73-.59,1.32-1.32,1.32Z"/>
    <path class="cls-3" d="m62.82,26.53c-.38,0-.76-.17-1.02-.48-.46-.56-.38-1.4.19-1.86l4.57-3.74c.56-.46,1.4-.38,1.86.19.46.56.38,1.4-.19,1.86l-4.57,3.74c-.25.2-.54.3-.84.3Z"/>
    <path class="cls-3" d="m70.8,42.23h-5.9c-.73,0-1.32-.59-1.32-1.32s.59-1.32,1.32-1.32h5.9c.73,0,1.32.59,1.32,1.32s-.59,1.32-1.32,1.32Z"/>
    <path class="cls-3" d="m67.47,60.85c-.22,0-.45-.06-.65-.17l-5.13-2.91c-.63-.36-.86-1.17-.5-1.8.36-.63,1.17-.85,1.8-.5l5.13,2.91c.63.36.86,1.17.5,1.8-.24.43-.69.67-1.15.67Z"/>
    <path class="cls-3" d="m27.25,26.94c-.29,0-.59-.1-.84-.3l-4.57-3.74c-.56-.46-.65-1.29-.19-1.86.46-.56,1.29-.65,1.86-.19l4.57,3.74c.56.46.65,1.29.19,1.86-.26.32-.64.48-1.02.48Z"/>
    <path class="cls-3" d="m25.17,42.64h-5.9c-.73,0-1.32-.59-1.32-1.32s.59-1.32,1.32-1.32h5.9c.73,0,1.32.59,1.32,1.32s-.59,1.32-1.32,1.32Z"/>
    <path class="cls-3" d="m22.6,61.26c-.46,0-.91-.24-1.15-.67-.36-.63-.14-1.44.5-1.8l5.13-2.91c.63-.36,1.44-.14,1.8.5.36.63.14,1.44-.5,1.8l-5.13,2.91c-.21.12-.43.17-.65.17Z"/>
  </g>
</svg>
</template>

<script>
export default {
    name: "CategoryInsightsIcon",
}
</script>


<style scoped>
  .cls-1 {
    fill: #115c72;
  }
  .cls-2 {
    fill: #59c5c7;
  }
  .cls-3 {
    fill: #b6dfcf;
  }
  .cls-4 {
    fill: #cfeae0;
    opacity: .71;
  }
</style>